module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-pearl-011-1200x2490.206374b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-pearl-011-1200x2490.jpg
// module id = 1099
// module chunks = 37